import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { error, log } from "logrocket";
import { withApollo } from "react-apollo";




const SEND_EVENT_NOTIFICATION = gql`
mutation($params: SendEventNotifications) {
    sendEventNotifications(params: $params)
}`
class PermissionModal extends React.Component {
    constructor() {
        super();
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
        }
    }

    handleHolidaysEvent = async (i) => {

        let params = {
            template_name: this.props.stateData.template_name.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.props.stateData.sendStudentsNotificationList[0].branch_id.toString(),
            request_title: this.props.stateData.sendStudentsNotificationList[0].request_title.toString(),
            parent_mobile: this.props.stateData.sendStudentsNotificationList.map((item) => item.parent_mobile).toString(),
            from_datetime: this.props.stateData.sendStudentsNotificationList[0].from_datetime.toString(),
            to_datetime: this.props.stateData.sendStudentsNotificationList[0].to_datetime.toString(),
        }
        console.log("params", params);
        this.setState({ loadingSpinner: 1 })

        this.sendEventNotifications(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 })
            setTimeout(() => {
                this.props.onHide();
            }, 1000);
        })

    };
    sendEventNotifications = async params => {

        await this.props.sendEventNotifications({
            variables: {
                params
            },

            update: (store, { data }) => {
                console.log("dataaaaaaaaaaaaaa", data);
                if (data.sendEventNotifications) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }

            }
        });
    };
    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();

    };


    render() {


        console.log("propsqaaaaaaaaaaaa", this.props);

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"

            >

                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Student Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">

                        <Row>
                            <Col sm={6}>
                                <Form.Label className='font-weight-bold fs-4'><span className="text-danger"> * </span>   If you want to Send  holiday Notification's On Below Students</Form.Label>
                            </Col>
                            <Col sm={6}>
                                <Row>
                                    <Col sm={12}>
                                        {this.state.currentStep == 5 ? (
                                            <Form.Text className=" text-success mb-2 fw-bold " style={{ textAlign: "center" }}>
                                                Notification sent successfully
                                            </Form.Text>
                                        ) : (
                                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                                {this.state.submitError}
                                            </Form.Text>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                                        <Button className="btn btn-dark" style={{ backgroundColor: "#213046" }} onClick={(e) => this.handleHolidaysEvent()}>
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : ""
                                            }
                                            Send Notification</Button>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} className='mt-3'>
                                <Table className="table  table-bordered table-hover ">
                                    <thead style={{ backgroundColor: "rgb(222,226,230)", color: "black" }}>


                                        <tr>
                                            <th>Sno</th>
                                            <th>Roll No</th>
                                            <th>Student Name</th>
                                            <th>Parent Name</th>
                                            <th>Parent Mobile</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ backgroundColor: "", textAlign: "center" }}>
                                        {
                                            this.props.stateData.sendStudentsNotificationList && this.props.stateData.sendStudentsNotificationList.length > 0 ? (
                                                this.props.stateData.sendStudentsNotificationList.map((item, index) => {
                                                    return (
                                                        <tr key={index} className='tableBody'>
                                                            <td>{index + 1}</td>
                                                            <td>{item?.roll_no}</td>
                                                            <td>{item?.student_name}</td>
                                                            <td>{item?.parent_name}</td>
                                                            <td>{item?.parent_mobile}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : ""
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>



                    </Modal.Body>
                </Container>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(SEND_EVENT_NOTIFICATION, {
        name: "sendEventNotifications"

    }),

)(PermissionModal)));





